import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex bg-white border-b h-18 border-gray-300" }
const _hoisted_2 = { class: "max-w-screen-2xl mx-auto w-full flex" }
const _hoisted_3 = { class: "flex items-center justify-center mx-4 space-x-4" }
const _hoisted_4 = {
  key: 0,
  class: "text-blurple-500 font-medium"
}
const _hoisted_5 = { class: "flex flex-grow" }
const _hoisted_6 = { class: "flex items-center mx-8" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Environment: UAT ")
const _hoisted_8 = { class: "font-medium text-gray-500" }
const _hoisted_9 = {
  key: 0,
  class: "border-t my-2 -mx-2"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-px my-3 bg-gray-300" }, null, -1)
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { class: "ml-4 font-medium text-base text-gray-900" }
const _hoisted_13 = {
  class: "w-56 p-4",
  "data-cy": "nav-account-menu"
}
const _hoisted_14 = { class: "text-sm font-semibold text-gray-500" }
const _hoisted_15 = {
  class: "font-semibold text-gray-900",
  "data-cy": "nav-account-name"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_17 = { class: "py-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_19 = { class: "pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrandLogo = _resolveComponent("BrandLogo")!
  const _component_MkBadge = _resolveComponent("MkBadge")!
  const _component_NavDropdownButton = _resolveComponent("NavDropdownButton")!
  const _component_PopoverButton = _resolveComponent("PopoverButton")!
  const _component_BasePopover = _resolveComponent("BasePopover")!
  const _component_BaseAvatar = _resolveComponent("BaseAvatar")!
  const _component_PopoverLink = _resolveComponent("PopoverLink")!
  const _component_SupportModal = _resolveComponent("SupportModal")!
  const _directive_allow = _resolveDirective("allow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BrandLogo),
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('platform.navigation.system-admin')), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "nav")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _renderSlot(_ctx.$slots, "right-content")
      ]),
      (_ctx.env !== 'prod')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["flex items-center", { 'mr-6': !_ctx.organisations.length || !_ctx.displayOrganisationsList }])
          }, [
            _createVNode(_component_MkBadge, {
              color: "danger",
              filled: ""
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.organisations.length && _ctx.displayOrganisationsList)
        ? (_openBlock(), _createBlock(_component_BasePopover, {
            key: 1,
            class: "mx-8",
            position: "left"
          }, {
            button: _withCtx(() => [
              _createVNode(_component_NavDropdownButton, { "data-dusk": "org-nav-btn" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.isAdmin ? _ctx.$t('platform.navigation.system-admin') : _ctx.currentOrganisation.name), 1)
                ]),
                _: 1
              })
            ]),
            menu: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organisations, (organisation) => {
                return (_openBlock(), _createBlock(_component_PopoverButton, {
                  key: organisation.id,
                  active: organisation.id === _ctx.currentOrganisation.id && !_ctx.isAdmin,
                  "data-cy": `org-${organisation.name.toLowerCase()}`,
                  onClick: ($event: any) => (_ctx.switchOrganisation(organisation))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(organisation.name), 1)
                  ]),
                  _: 2
                }, 1032, ["active", "data-cy", "onClick"]))
              }), 128)),
              (_ctx.organisations.length && _ctx.user.is_admin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                : _createCommentVNode("", true),
              (_ctx.user.is_admin)
                ? (_openBlock(), _createBlock(_component_PopoverButton, {
                    key: 1,
                    active: _ctx.isAdmin,
                    icon: "workstation",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.accessDomainAdmin()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('platform.navigation.system-admin')), 1)
                    ]),
                    _: 1
                  }, 8, ["active"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _hoisted_10,
      (_ctx.user)
        ? (_openBlock(), _createBlock(_component_BasePopover, {
            key: 2,
            position: "left",
            class: "mx-8"
          }, {
            button: _withCtx(() => [
              _createVNode(_component_NavDropdownButton, { "data-dusk": "nav-account-btn" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_BaseAvatar, {
                      url: _ctx.url,
                      "user-name": _ctx.userName
                    }, null, 8, ["url", "user-name"]),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('platform.common.account')), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            menu: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('platform.navigation.signed-in-as')), 1),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.user.given_name) + " " + _toDisplayString(_ctx.user.family_name), 1)
              ]),
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_PopoverLink, { to: "/settings/profile" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('platform.settings.profile')), 1)
                  ]),
                  _: 1
                }),
                (!_ctx.isAdmin)
                  ? _withDirectives((_openBlock(), _createBlock(_component_PopoverLink, {
                      key: 0,
                      "data-dusk": "my-organisation-link",
                      to: "/settings/users"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('platform.settings.my-organisation')), 1)
                      ]),
                      _: 1
                    })), [
                      [_directive_allow, 'org-unit-setting:read']
                    ])
                  : _createCommentVNode("", true)
              ]),
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                (_ctx.$customer === 'MENICON')
                  ? (_openBlock(), _createBlock(_component_PopoverButton, {
                      key: 0,
                      icon: "support",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSupportModal = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('platform.common.support')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_PopoverButton, {
                  "data-dusk": "logout-btn",
                  icon: "signout",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.logout()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('platform.common.sign-out')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.showSupportModal)
        ? (_openBlock(), _createBlock(_component_SupportModal, {
            key: 3,
            onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showSupportModal = false))
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}